const SUBMIT_KEYS = /* @__PURE__ */ new Set(["Enter", " "]);
export {
  SUBMIT_KEYS as S
};
